const menuEndpoints = {
  getMenuCategoryByOperator: "/menu/getMenuCategoryByOperator",
  getMenuItemsByCategory: "/menu/getMenuItemsByCategory",
  createCategoryMenu: "/menu/createCategoryMenu",
  deleteCategoryMenu: "/menu/deleteCategoryMenu",
  updateCategoryMenu: "/menu/updateCategoryMenu",
  createMenuItem: "/menu/createMenuItem",
  updateMenuItem: "/menu/updateMenuItem",
  deleteMenuItem: "/menu/deleteMenuItem",
};

export default menuEndpoints;
